import { render, staticRenderFns } from "./Nastaveni.vue?vue&type=template&id=422b02ba&scoped=true&"
import script from "./Nastaveni.vue?vue&type=script&lang=js&"
export * from "./Nastaveni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422b02ba",
  null
  
)

export default component.exports